/* eslint-disable import/prefer-default-export */
import axios from 'axios'

const { NITRO_PIXEL_PRO_API } = process.env

const apiNitroPixelPro = axios.create({
  baseURL: NITRO_PIXEL_PRO_API,
  withCredentials: true,
  timeout: 960000,
  headers: {
    'Content-Type': 'application/json',
  },
})

const apiNitroPixelProAecorsoft = axios.create({
  baseURL: 'https://us-west1-ingesta-sap-aecorsoft.cloudfunctions.net/',
  withCredentials: true,
  timeout: 960000,
  headers: {
    'Content-Type': 'application/json',
  },
})

apiNitroPixelPro.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response.status === 403) {
      sessionStorage.setItem('userStatus', '')
      window.location.href = '/'
    }
    return Promise.reject(error)
  },
)

export { apiNitroPixelPro, apiNitroPixelProAecorsoft }
